import React, { Component, Fragment } from 'react'
import { Container,Row, Col } from 'react-bootstrap'
import tableS from '../../asset/image/table_S.jpg'
import createAcocunt from '../../asset/image/createAccount.jpg'
import BookNow from '../../asset/image/booknow.jpg'
import Payment from '../../asset/image/pay.png'
import Seeyou from '../../asset/image/seeyou.jpg'

export class WorkFlow extends Component {
  render() {
    return (
     <Fragment>
        <Container fluid={true} className='text-center containerS'>
      <hr />
        
             <h1 className='h1Tag '>WorkFlow</h1>
            <div className='bottom'></div>
             <Row className=''>
                <Col lg={3} md={6} sm={12}>
                  <img className='circleImage' src={createAcocunt} />
                           
                                 <h1 className='workh1Tag'>Create Your Account  {'\u2192'}</h1>
                        
                                
           
                </Col>
                 <Col lg={3} md={6} sm={12}>
                  <img className='circleImage' src={BookNow}/>
                                 <h1 className='workh1Tag'>Book Your Event Stall →</h1>
                        
                              
           
                </Col>
                 <Col lg={3} md={6} sm={12}>
                  <img className='circleImage' src={Payment}/>
                                 <h1 className='workh1Tag'>Make Payments →</h1>
                        
                           
           
                </Col>
 <Col lg={3} md={6} sm={12}>
                  <img className='circleImage' src={Seeyou}/>
                                 <h1 className='workh1Tag'>See You At Events</h1>
                        
                                 
           
                </Col>

            </Row>
                 
        </Container>
     </Fragment>
    )
  }
}

export default WorkFlow
